$(".product__carousel-main").slick({
    initialSlide: 3,
    dots: !1,
    fade: !0,
    arrows: !1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    asNavFor: ".product__carousel-carousel",
    responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: !0, dots: !0 } }],
}),
$(".product__carousel-carousel").slick({
    initialSlide: 3,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product__carousel-main",
    dots: !1,
    arrows: !1,
    centerMode: !0,
    focusOnSelect: !0,
    responsive: [{ breakpoint: 768, settings: "unslick" }],
})